<template>
  <div class="dialog-welcome" v-if="viewable">
    <dialog-zoomer v-on:close="lbHide" v-model="viz">
      
      <div class="welcome-panel">
        <div style="padding:25px;background-color:#fff">
          <img src="../../assets/img/redxicon.svg" style="width:200px;height:200px" />
        </div>
        <div class="pop-black">
          <div class="close-box small lb" v-on:click="lbHide"></div>
          <div class="pop-b-head">
            Illustration is now
            <div style="color:#ce0e2d">
              IllustrationX
            </div>
          </div>
          <div class="pop-b-body">
            We've added an X to stand for the extra edge we offer by connecting 
            you to the world's leading illustrators and animators. Enjoy!
          </div>
        </div>
        
      </div>
    </dialog-zoomer>
  </div>
</template>

<script>
import DialogZoomer from './DialogZoomer.vue'
const poplangs = ['UK', 'US', 'SG', 'AU','IN']

export default {
  components: {
    DialogZoomer
  },
  data() {
    return {
      viewable: false,
      viz: false
    }
  },
  created() {
    if(!this.$k.isBot()){
      if(localStorage.seenDialogIntro !== 'true') {
        if(poplangs.includes(this.$store.state.lang)) {
          this.viewable = true
        }
      }
    }
  },
  mounted() {
    this.launch()
  },
  methods: {
    async launch() {
      await this.$k.waitfor(3000)
      this.viz = true
    },
    lbHide() {
      localStorage.seenDialogIntro = 'true'
      this.viewable = false
    }
  }

}
</script>

<style scoped>
.welcome-panel{
  width:550px;
  max-width:90%;
  display:flex;
}
.pop-black{
  background-color:#000;
  color:#fff;
  display:flex;
  flex-direction: column;
  justify-content: center;
  padding:20px;
  position:relative;
}
.pop-b-head{
  font-size:23px;
  line-height:26px;
  margin-bottom:16px;
}
.pop-b-body{
  font-size:15px;
  line-height:18px;
}

.close-box.small.lb{
  background-image:url('../../assets/img/close-light-brown.svg');
  top:10px;
  right:10px;
}
.close-box.small.lb:hover{
  background-image:url('../../assets/img/close-red.svg');
  transform:none;
}
</style>